export default __webpack_public_path__ + "/dist/images/968140.25d6e409a041f8faca8291b891b1b164.png";